import _ from 'underscore';
import React, { useCallback, useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import { Controls, ControlsBlock } from 'components/Controls';
import FilterButton from 'components/FilterButton';
import Search from 'components/filters/Search';

import { useDeepEffect } from 'hooks/useDeepEffect';

import FilterModal from 'components/filters/FilterModal';
import MobileSelect from 'components/filters/MobileSelect';

import { sortOptions } from 'components/filters/SortFilters';
import MobileList from './components/MobileList';

import styles from './styles.module.scss';

const MobileControls = ({
	onFilterChange,
	filters,
	onFilterReset,
	defaultFiltersValues,
	filtersLoading,
	rubricPath
}) => {
	const [isModalOpened, setIsModalOpened] = useState(false);
	const [filterData, setFilterData] = useState(null);
	const [filterStatus, setFilterStatus] = useState(false);
	const [filterList, setFilterList] = useState({});
	const [filterOptions, setFilterOptions] = useState({});

	useEffect(() => {
		setFilterOptions(filters);
	}, [filters]);

	const setFilter = useCallback(
		(filterName, filterValue) => {
			setFilterStatus(false);

			onFilterChange(filterName, filterValue);
			setFilterData(null);
		},
		[onFilterChange]
	);

	useDeepEffect(() => {
		setFilterList({
			sort: {
				options: sortOptions,
				name: 'sort',
				selectedValue: filters.sort,
				label: 'Сортировка',
				resetOption: sortOptions.find(
					(option) => option.name === defaultFiltersValues.sort
				),
				onChange: setFilter,
				controlTitleField: 'title',
				valueField: 'name',
				alwaysHideResetOption: true
			}
		});
	}, [setFilter]);

	const switchFilter = (data, status) => {
		setFilterData(data);
		setFilterStatus(status);
	};

	const toggleModal = () => {
		setIsModalOpened((prev) => !prev);
	};

	const closeModal = () => {
		switchFilter(null, false);

		if (!filterData) {
			toggleModal();
		}
	};

	const resetOneFilter = (name) => {
		const filter = filterList[name];
		const omitFilters = _(filterOptions).omit(name);

		setFilterOptions(omitFilters);
		const resetValue = filter?.resetOption
			? filter?.resetOption[filter?.valueField || 'value']
			: defaultFiltersValues[name];

		onFilterChange(name, resetValue);
	};

	return (
		<>
			<div className={styles.MobileControls}>
				<Controls right={<FilterButton onClick={toggleModal} />}>
					<ControlsBlock className={styles.MobileControls__Block}>
						<Search
							onEnter={onFilterChange}
							defaultTitle="Поиск"
							placeholder=""
							value={filters.query}
						/>
					</ControlsBlock>

					<FilterModal
						modalStatus={isModalOpened}
						modalHandler={toggleModal}
						closeHandler={closeModal}
						label={filterData?.label}
						className={styles.MobileControls__Modal}
					>
						<div className={styles.MobileControls__ModalContent}>
							{filterStatus && !_.isEmpty(filterData) ? (
								<MobileSelect
									{...filterList[filterData.name]}
									filterOptions={filterOptions}
									selectedValue={filterOptions[filterData.name]}
									isLoading={filtersLoading}
								/>
							) : (
								<MobileList
									{...{
										defaultFiltersValues,
										filterOptions,
										rubricPath,
										switchFilter,
										filters,
										filterList,
										onFilterChange,
										onFilterReset,
										resetOneFilter,
										onChange: setFilter,
										setModalStatus: setIsModalOpened
									}}
								/>
							)}
						</div>
					</FilterModal>
				</Controls>
			</div>
		</>
	);
};

MobileControls.propTypes = {
	onFilterChange: PropTypes.func,
	onFilterReset: PropTypes.func,
	filters: PropTypes.shape({
		query: PropTypes.string,
		sort: PropTypes.string
	}),
	defaultFiltersValues: PropTypes.object,
	filtersLoading: PropTypes.bool,
	rubricPath: PropTypes.string
};

MobileControls.defaultProps = {
	onFilterChange: _.noop,
	filters: {},
	defaultFiltersValues: {}
};

export default MobileControls;
